import { render, staticRenderFns } from "./c9EditNewBusinessForm.vue?vue&type=template&id=0a5b4824"
import script from "./c9EditNewBusinessForm.vue?vue&type=script&lang=js"
export * from "./c9EditNewBusinessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports